/* Cart drawer extras: paid gift wrap switch, upsell quick-add, discount code box,
   copy and apply code. Uses event delegation on document, because Dawn
   re-renders the drawer HTML after every cart change and replaced elements
   lose their own listeners. */
(function () {
  if (window.__cdxReady) return;
  window.__cdxReady = true;

  var HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function updateAttributes(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: HEADERS,
      body: JSON.stringify({ attributes: attrs })
    }).then(function (res) {
      if (!res.ok) throw new Error('Could not save');
      return res.json();
    });
  }

  function renderDrawer(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.renderContents) drawer.renderContents(state);
  }

  function checkState(state, fallback) {
    if (state.status || !state.sections) {
      throw new Error(state.description || state.message || fallback);
    }
    return state;
  }

  // Adds a code to the cart (or clears all codes when code is ''), then redraws the drawer.
  function setDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: HEADERS,
      body: JSON.stringify({ discount: code, sections: SECTIONS, sections_url: window.location.pathname })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (state) {
        checkState(state, 'Could not update the discount code');
        renderDrawer(state);
        return state;
      });
  }

  // Re-reads the drawer from the server, so what is shown always matches the real cart.
  function refreshDrawer() {
    return fetch('/?sections=' + SECTIONS, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        renderDrawer({ sections: sections });
      });
  }

  function failIfError(res) {
    return res.json().then(function (data) {
      if (!res.ok || data.status) {
        throw new Error(data.description || data.message || 'Something went wrong');
      }
      return data;
    });
  }

  // Turns gift wrap on (adds the Gift Wrap product) or off (removes that cart line).
  function setGiftWrap(on, gv) {
    if (on) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: HEADERS,
        body: JSON.stringify({ items: [{ id: gv, quantity: 1 }] })
      }).then(failIfError);
    }
    return updateAttributes({ 'Gift message': '' })
      .catch(function () {})
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
          return res.json();
        });
      })
      .then(function (cart) {
        var line = cart.items.filter(function (i) {
          return i.variant_id === gv;
        })[0];
        if (!line) return null;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: HEADERS,
          body: JSON.stringify({ id: line.key, quantity: 0 })
        }).then(failIfError);
      });
  }

  function showGiftError(message) {
    setTimeout(function () {
      var el = document.querySelector('.cdx-gift__err');
      if (el) el.textContent = message || 'Could not update gift wrap. Please try again.';
    }, 60);
  }

  // If every real product has been removed, drop the gift wrap too, so the cart is not left with only gift wrap.
  function cleanupOrphanGiftWrap() {
    var sw = document.querySelector('[data-cdx-giftwrap]');
    var gv = sw ? Number(sw.getAttribute('data-variant')) : 0;
    if (!gv) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var gift = cart.items.filter(function (i) {
          return i.variant_id === gv;
        });
        if (gift.length && cart.items.length === gift.length) {
          return setGiftWrap(false, gv).then(refreshDrawer);
        }
      })
      .catch(function () {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, cleanupOrphanGiftWrap);
  }

  function applyCodeFromBox(box) {
    var input = box.querySelector('[data-cdx-code-input]');
    var msg = box.querySelector('[data-cdx-code-msg]');
    var btn = box.querySelector('[data-cdx-code-apply]');
    var code = (input && input.value ? input.value : '').trim();
    if (!code) {
      if (msg) msg.textContent = 'Enter a code first.';
      return;
    }
    if (msg) msg.textContent = '';
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Applying…';
    setDiscount(code)
      .then(function () {
        // The drawer has been redrawn. If the code box is still showing, the code did not apply.
        setTimeout(function () {
          var again = document.querySelector('[data-cdx-code-msg]');
          if (again) {
            again.textContent =
              "That code doesn't apply to your cart right now. Check the spelling or the items it needs. You can also enter it at checkout.";
          }
        }, 60);
      })
      .catch(function (ex) {
        btn.disabled = false;
        btn.textContent = label;
        if (msg) msg.textContent = ex.message;
      });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target && e.target.closest && e.target.closest('[data-cdx-code-input]');
    if (!input) return;
    e.preventDefault();
    applyCodeFromBox(input.closest('.cdx-coupon'));
  });

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var sw = target.closest('[data-cdx-giftwrap]');
    if (sw) {
      var gv = Number(sw.getAttribute('data-variant'));
      var on = sw.checked;
      sw.disabled = true;
      setGiftWrap(on, gv)
        .then(refreshDrawer)
        .catch(function (ex) {
          // Whatever went wrong, redraw from the real cart so the switch and total are truthful.
          return refreshDrawer()
            .catch(function () {
              sw.checked = !on;
              sw.disabled = false;
            })
            .then(function () {
              showGiftError(ex && ex.message);
            });
        });
      return;
    }

    var msg = target.closest('[data-cdx-gift-message]');
    if (msg) updateAttributes({ 'Gift message': msg.value.trim() }).catch(function () {});
  });

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    // Backup for the orphan check: after a remove or quantity click, look again shortly.
    if (target.closest('cart-remove-button, .quantity__button')) {
      setTimeout(cleanupOrphanGiftWrap, 1500);
    }

    var add = target.closest('[data-cdx-add]');
    if (add) {
      var card = add.closest('.cdx-upsell__card');
      var select = card && card.querySelector('[data-cdx-variant]');
      var variantId = select ? select.value : add.getAttribute('data-variant');
      var err = card && card.querySelector('.cdx-upsell__err');
      var label = add.textContent;
      if (err) err.textContent = '';
      add.disabled = true;
      add.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: HEADERS,
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: SECTIONS,
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (state) {
          checkState(state, 'Could not add this item');
          renderDrawer(state);
        })
        .catch(function (ex) {
          add.disabled = false;
          add.textContent = label;
          if (err) err.textContent = ex.message;
        });
      return;
    }

    var codeApply = target.closest('[data-cdx-code-apply]');
    if (codeApply) {
      applyCodeFromBox(codeApply.closest('.cdx-coupon'));
      return;
    }

    var codeRemove = target.closest('[data-cdx-code-remove]');
    if (codeRemove) {
      codeRemove.disabled = true;
      setDiscount('').catch(function () {
        codeRemove.disabled = false;
      });
      return;
    }

    var copy = target.closest('[data-cdx-copy]');
    if (copy) {
      var code = copy.getAttribute('data-cdx-copy');
      var original = copy.textContent;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () {
          copy.textContent = 'Copied';
          setTimeout(function () {
            copy.textContent = original;
          }, 1500);
        }).catch(function () {});
      }
      return;
    }

    // "Apply code" in the free heart hook progress card: applies the code in the cart for real.
    var apply = target.closest('[data-cdx-apply]');
    if (apply) {
      var discount = apply.getAttribute('data-cdx-apply');
      var aLabel = apply.textContent;
      apply.disabled = true;
      apply.textContent = 'Applying…';
      setDiscount(discount).catch(function () {
        apply.disabled = false;
        apply.textContent = aLabel;
      });
    }
  });
})();
